import { createSelector } from 'reselect';


const getSelectedVideoIdFromStore = state => state.selectedVideoId;
const getVideoIdFromUrl = (state, props) => _.get(props, 'channelVideoData.id');
const getFeaturedVideoId = (state, props) => _.get(props, 'channelData.featuredItem');
const getFirstVideoFromList = (state, props, listType) => (_.get(state.lazyVideoLists[listType], 'idChunks[0][0]') || _.get(state.lazyVideoLists[listType], 'videoIds[0]'));

export const getMainVideoId = createSelector(
  [getSelectedVideoIdFromStore, getVideoIdFromUrl, getFeaturedVideoId, getFirstVideoFromList],
  (selectedVideoId, idFromUrl, featuredVideoId, firstVideoId) =>
    selectedVideoId || idFromUrl || featuredVideoId || firstVideoId
);



// WEBPACK FOOTER //
// ./src/widget/ui-selectors/selected-video-id.js